import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { TostadorFetching } from "../../../class/fetchTostador";
import { plotBackground } from "../../../config/colors";
import { useDate } from "../../../hooks/useDate";
import { getValoresPeriodo } from "../../../services/services";
import formatDate from "../../../utils/formatDate";
import LoadingChart from "../../Home/components/loadingChart";
import "../Tostador.css";

export default function CorrienteEDP() {
  const initialFetch = new TostadorFetching().setIdSeccion(4).setSecuencia(41);
  const corrienteEDP = new TostadorFetching().setIdSeccion(3).setSecuencia(41);

  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  // Custom hook que nos ayuda a extraer la fecha inicial y final
  const { setDateHook, fullDate } = useDate();
  const [isLoading, setIsLoading] = useState(true);

  const [corrienteEDP9, setCorrienteEDP9] = useState(defaultObject);
  const [corrienteEDP10, setCorrienteEDP10] = useState(defaultObject);
  const [corrienteEDP3, setCorrienteEDP3] = useState(defaultObject);
  const [corrienteEDP1, setCorrienteEDP1] = useState(defaultObject);
  const [corrienteEDP2, setCorrienteEDP2] = useState(defaultObject);

  useEffect(() => {
    // Peticion de datos al API
    async function fetchData() {
      setIsLoading(true);
      // Solo nos traemos la data de la peticion
      const { data } = await getValoresPeriodo(initialFetch);

      const fetchData = await getValoresPeriodo(corrienteEDP);

      if (fetchData.data) {
        populateCorrienteEDP1(fetchData.data);
        populateCorrienteEDP2(fetchData.data);
      }

      if (data) {
        populateCorrienteEDP9(data);
        populateCorrienteEDP10(data);
        populateCorrienteEDP3(data);

        // usamos el hook de fecha para guardar los datos del periodo
        setDateHook(data, "Corriente EDP 9");
      }

      setIsLoading(false);
    }

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function populateCorrienteEDP9(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 9"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteEDP9({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP10(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 10"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteEDP10({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP3(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 3"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteEDP3({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP1(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 1"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteEDP1({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateCorrienteEDP2(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Corriente EDP 2"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(formatDate(element.Fecha));
    });

    setCorrienteEDP2({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart
              plotBackgroundColor={plotBackground}
              title={"Perfil Corriente EDP 9 - 10 - 3 - 1 - 2"}
              subtitle={"Periodo " + fullDate()}
            >
              {/** -------------------------------- Corriente EDP 9 --------------------------------------- */}
              <Chart.Line
                name="Corriente EDP 9"
                data={corrienteEDP9.value}
                yAxis={0}
              />

              {/** -------------------------------- Corriente EDP 10 --------------------------------------- */}
              <Chart.Line
                name="Corriente EDP 10"
                data={corrienteEDP10.value}
                yAxis={0}
              />

              {/** -------------------------------- Corriente EDP 3 --------------------------------------- */}
              <Chart.Line
                name="Corriente EDP 3"
                data={corrienteEDP3.value}
                yAxis={0}
              />

              {/** -------------------------------- Corriente EDP 1 --------------------------------------- */}
              <Chart.Line
                name="Corriente EDP 1"
                data={corrienteEDP1.value}
                yAxis={1}
              />

              {/** -------------------------------- Corriente EDP 2 --------------------------------------- */}
              <Chart.Line
                name="Corriente EDP 2"
                data={corrienteEDP2.value}
                yAxis={1}
              />

              {/** -------------------------------- FECHAS --------------------------------------- */}
              <Chart.XAxis categories={corrienteEDP9.fecha} />

              <Chart.YAxis
                labelSuffix=" A"
                title="Corriente 3 - 9 - 10, A"
                lineWidth={2}
                lineColor="white"
              />

              <Chart.YAxis
                labelSuffix=" A"
                title="Corrientes 1 - 2, A"
                lineWidth={2}
                lineColor="white"
                opposite={true}
              />

              <Chart.Tooltip valueSuffix=" % " />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
